import React from 'react';

const OnSite = (props) => {
    return (
        <svg width="24" height="24" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M13.724 5.05632C13.724 2.47632 11.6373 0.389648 9.05734 0.389648C6.47734 0.389648 4.39068 2.47632 4.39068 5.05632C4.39068 7.36965 6.07068 9.28298 8.27734 9.64965V12.2763H2.94401V10.2763H3.61068V7.60965C3.61068 7.24298 3.31068 6.94298 2.94401 6.94298H0.94401C0.577344 6.94298 0.277344 7.24298 0.277344 7.60965V10.2763H0.94401V13.6096H11.6107V12.2763H9.61068V9.68965C11.924 9.41632 13.724 7.44965 13.724 5.05632ZM1.94401 4.27629C1.39173 4.27629 0.94401 4.724 0.94401 5.27629C0.94401 5.82857 1.39173 6.27629 1.94401 6.27629C2.4963 6.27629 2.94401 5.82857 2.94401 5.27629C2.94401 4.724 2.4963 4.27629 1.94401 4.27629ZM5.72401 5.05631C5.72401 6.89631 7.21734 8.38965 9.05734 8.38965C10.8973 8.38965 12.3907 6.89631 12.3907 5.05631C12.3907 3.21632 10.8973 1.72298 9.05734 1.72298C7.21734 1.72298 5.72401 3.21632 5.72401 5.05631Z"
            />
        </svg>

    )
}

export default OnSite;